<template>
  <div>
    <md-dialog
      :class="modal == 'true' ? 'md-dialog-modal' : 'md-dialog-modal-none'"
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title v-if="errorType != 'notSession'" class="text-center"
        >Return to {{ Session.siteName }}</md-dialog-title
      >
      <md-dialog-title v-if="errorType == 'notSession'" class="text-center"
        >Can not find Session</md-dialog-title
      >
      <md-dialog-content>
        <h6 v-if="errorType != 'notSession'" class="text-center">
          Your session is processing or there is an error. please access new session.
        </h6>
        <h6 v-if="errorType == 'notSession'" class="text-center">
          Please confirm session
        </h6>
        <ul class="just-content-center"></ul>
        <md-dialog-actions>
          <md-button
            v-if="errorType != 'notSession'"
            class="md-raised md-primary btn-element"
            @click="Close()"
            >Return to {{ Session.siteName }}</md-button
          >
        </md-dialog-actions>
        <div class="text-center">
          <img class="logo-size" src="@/assets/logo.png" />
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "HandleError",

  data: () => ({
    logIn: true,
    modal: true,
    showDialog: true,
    errorType: "",
    Session: {},
  }),

  methods: {
    Close() {
      window.location.href = this.Session.returnUrlCancelled.replace('[sessionId]', this.Session.guid);
      this.showDialog = false;
    },
    onResize({ width, height }) {
      window.onResizeHandler(width, height);
    },
    
  },
  mounted() {
    this.modal = this.$route.params.modal;
    this.errorType = this.$route.params.type;
    this.Session = this.$route.params.session;
    console.log("mounted_error_dialog", this.modal);
  },
};
</script> 

<style lang="scss" scoped>
.logo-size {
  width: 150px;
  height:38px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #73c773;
  border-radius: 10px;
  padding-left: 100px;
  padding-right: 100px;
  color: white !important;
}

.md-dialog-actions {
  justify-content: center;
}

.btn-element {
  margin: 1% !important;
  color: black !important;
  font-size: 12px;
}
ul {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}

.md-dialog-modal-none {
  right: unset;
  bottom: unset;
  z-index: 1;
  ::v-deep .md-dialog-container {
    box-shadow: none;
    max-width: 100%;
  }
}

.md-dialog-modal {
  z-index: 1;
  ::v-deep .md-dialog-container {
    max-width: 500px;
    border-radius: 20px !important;
    border: 3px solid black;
  }
}
</style>